export default class ErnApi {
    constructor(base) {
        this.base = base;
        this.baseUrl = this.base.cfg.VUE_APP_TRANSACTIONS_API_BASE_ADDRESS;
        this.ernUrl = this.baseUrl + '/api/integrations/ern';
    }

    async transmit(paymentTransactionID, voiceAuthorizationNumber = null) {
        return await this.base.post(this.ernUrl + '/transmit',
            { paymentTransactionID, voiceAuthorizationNumber },
            { showSuccessToastr: false, showBadRequestToastr: false });
    }
}
